export namespace Auth {
  export const THOR_AI_PRODUCT_ID = "thor_ai";

  export enum UserGroup {
    OwnerGroup = "OwnerGroup",
    SuperAdminGroup = "SuperAdminGroup",
    AdminGroup = "AdminGroup",
    ClientAdminGroup = "ClientAdminGroup",
    ClientUserGroup = "ClientUserGroup"
  }

  export enum Permission {
    PUBLIC = "public",
    SOURCE_CREATE = "source:create",
    SOURCE_PATCH = "source:patch",
    SOURCE_STATUS_PATCH = "source:status:patch",
    SOURCE_DATA_RELOAD = "source:data:reload",
    CUSTOMER_CREATE = "customer:create",
    CUSTOMER_LIST = "customer:list",
    CUSTOMER_PATCH = "customer:patch",
    CUSTOMER_DELETE = "customer:delete",
    CONTENT_UPSERT = "content:upsert",
    REPORT_CREATE = "report:create",
    REPORT_DOWNLOAD = "report:download",
    REPORT_LIST = "report:list",
    REPORT_CONFIRM = "report:confirm",
    REPORT_SUMMARY_LIST = "report:summary:list",
    REPORT_SUMMARY_GENERATE = "report:summary:generate",
    REPORT_PROMPT_GET = "report:prompt:get",
    REPORT_PROMPT_UPDATE = "report:prompt:update"
  }
}

export default Auth;
